































































































































































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import MonthSelectorVue from "../components/MonthSelector.vue";
import { mapGetters } from "vuex";

interface TaxType {
    id: number | null;
    name?: string;
    children: TaxType[];
}

@Component({
    ...mapGetters(["accountBook"]),
    components: {
        "month-selector": MonthSelectorVue,
    },
})

export default class StampTax extends Vue {
    tax: any = {};
    stampTaxList: any = [];
    newRow: {
        type: TaxType;
        childType: TaxType | null;
        taxAmount: string;
        approvalBasis: string;
        approvedRatio: string;
        taxRate: string;
        currentTaxPay: string;
        currentTaxPaid: string;
        codeDeduction: string;
        taxDeduction: string;
        deduction: string;
        name: string;
        number: string;
        fillRefundTaxAmount: string;
    } = {
        type: {
            id: null,
            children: []
        },
        childType: null,
        taxAmount: "",
        approvalBasis: "",
        approvedRatio: "0",
        taxRate: "",
        currentTaxPay: "",
        currentTaxPaid: "",
        codeDeduction: "",
        taxDeduction: "",
        deduction: "",
        name: "",
        number: "",
        fillRefundTaxAmount: "",
    };
    mainBodyList = [
        { id: 1, name: "增值税小规模纳税人" },
        { id: 2, name: "小型微利企业（增值税一般纳税人）" },
        { id: 3, name: "个体工商户（增值税一般纳税人）" },
    ]
    taxTypes = [
        {
            id: 19,
            name: "买卖合同",
            children: []
        },
        {
            id: 20,
            name: "承揽合同",
            children: [
                { name: "修理合同", id: 2001 },
                { name: "复制合同", id: 2002 },
                { name: "测试合同", id: 2003 },
                { name: "检验合同", id: 2004 },
                { name: "加工合同", id: 2005 },
                { name: "定作合同", id: 2006 },
            ]
        },
        {
            id: 21,
            name: "建设工程合同",
            children: [
                { name: "工程勘察合同", id: 2101 },
                { name: "工程设计合同", id: 2102 },
                { name: "工程施工合同", id: 2103 },
            ]
        },
        {
            id: 22,
            name: "运输合同",
            children: [
                { name: "公路货物运输合同", id: 2201 },
                { name: "水路货物运输合同", id: 2202 },
                { name: "航空货物运输合同", id: 2203 },
                { name: "铁路货物运输合同", id: 2204 },
                { name: "多式联运合同", id: 2205 },
            ]
        },
        {
            id: 2,
            name: "技术合同",
            children: [
                { name: "技术开发合同", id: 201 },
                { name: "技术许可合同", id: 202 },
                { name: "技术咨询合同", id: 203 },
                { name: "技术服务合同", id: 204 },
            ]
        },
        {
            id: 23,
            name: "租赁合同",
            children: [
                { name: "房屋租赁合同", id: 2301 },
                { name: "其他租赁合同", id: 2302 },
            ]
        },
        {
            id: 24,
            name: "保管合同",
            children: []
        },
        {
            id: 25,
            name: "仓储合同",
            children: []
        },
        {
            id: 13,
            name: "产权转移书据",
            children: [
                { name: "土地使用权出让书据", id: 1301 },
                { name: "土地使用权转让书据", id: 1302 },
                { name: "房屋等建筑物和构筑物所有权转让书据（不包括土地承包经营权和土地经营权转移）", id: 1303 },
                { name: "股权转让书据（不包括应缴纳证券交易印花税的）", id: 1304 },
                { name: "商标专用权转让书据", id: 1305 },
                { name: "著作权转让书据", id: 1306 },
                { name: "专利权转让书据", id: 1307 },
                { name: "专有技术使用权转让书据", id: 1308 },
            ]
        },
        {
            id: 8,
            name: "借款合同",
            children: [
                { name: "银行业金融机构借款合同", id: 801 },
                { name: "其他金融机构借款合同", id: 802 },
            ]
        },
        {
            id: 26,
            name: "融资租赁合同",
            children: []
        },
        {
            id: 9,
            name: "财产保险合同",
            children: []
        },
        {
            id: 27,
            name: "营业账簿",
            children: []
        },
        {
            id: 1,
            name: "购销合同",
            children: []
        },
        {
            id: 3,
            name: "货物运输合同",
            children: []
        },
        {
            id: 4,
            name: "加工承揽合同",
            children: []
        },
        {
            id: 5,
            name: "仓储保管合同",
            children: []
        },
        {
            id: 6,
            name: "财产租赁合同",
            children: []
        },
        {
            id: 7,
            name: "建筑安装承包合同",
            children: []
        },
        {
            id: 10,
            name: "财产转移书据",
            children: []
        },
        {
            id: 11,
            name: "资金账簿",
            children: []
        },
        {
            id: 12,
            name: "权力许可证照",
            children: []
        },
        {
            id: 14,
            name: "建设工程勘察设计合同",
            children: []
        },
        {
            id: 15,
            name: "建筑安装工程承包合同",
            children: []
        },
        {
            id: 16,
            name: "其他营业账簿",
            children: []
        },
        {
            id: 17,
            name: "利息收入",
            children: []
        },
        {
            id: 18,
            name: "其他凭证",
            children: []
        },
    ];
    period: string = "";
    time: string = "";

    mounted() { }
    // 切换纳税申报表
    changeType(val: number) {
        if (val === 1) this.fetchData();
        else this.$router.push({ path: "/declaration" });
    }

    // 选择时间
    changeDate(start: string, end: string) {
        console.log(start, end);
        if (this.$store.state.accountBook.taxFormDto.isStampMonth === 0) {
            this.period = end
        } else {
            this.period = start

        }
        this.fetchData();
    }

    resetNewRow() {
        this.newRow = {
            type: {
                id: null,
                children: []
                // name: "购销合同",
            },
            childType: null,
            taxAmount: "",
            approvalBasis: "",
            approvedRatio: "",
            taxRate: "",
            currentTaxPay: "",
            currentTaxPaid: "",
            codeDeduction: "",
            taxDeduction: "",
            deduction: "",
            fillRefundTaxAmount: "",
            name: "",
            number: ""
        };
    }
    cb() {
        if (
            this.newRow.taxAmount != "" &&
            this.newRow.approvalBasis != "" &&
            this.newRow.currentTaxPaid != "" &&
            this.newRow.codeDeduction != "" &&
            this.newRow.taxDeduction != "" &&
            this.newRow.name != "" &&
            this.newRow.number != "" &&
            this.newRow.deduction != ""
        ) {
            this.stampTaxList.push(this.newRow);
            this.resetNewRow();
            this.tax.stampTaxList = this.stampTaxList;
            this.changeRow();
        }
    }
    fetchData() {
        Vue.axios
            .get(
                `stamptax?accountBookId=${this.$store.state.accountBook.id}&period=${this.period}`
            )
            .then((res) => {
                res.data.stampTaxList.forEach((e: any) => {
                    for (let i = 0; i < this.taxTypes.length; i++) {
                        if (+e.type === this.taxTypes[i].id) {
                            e.type = this.taxTypes[i];
                            e.childTypeList = e.type.children;
                            for (let j = 0; j < e.childTypeList.length; j++) {
                                if (+e.childType === e.childTypeList[j].id) {
                                    e.childType = e.childTypeList[j];
                                    break;
                                }
                            }
                            break;
                        }
                    }
                });
                this.tax = res.data;
                this.stampTaxList = res.data.stampTaxList;
                this.time =
                    this.tax.startPeriod.substring(0, 4) +
                    "年" +
                    this.tax.startPeriod.substring(4) +
                    "月" +
                    "至" +
                    this.tax.endPeriod.substring(0, 4) +
                    "年" +
                    this.tax.endPeriod.substring(4) +
                    "月";
            });
    }
    changeRow(val?: any, row?: any) {
        if (val && row) {
            row.childTypeList = val.children;
            row.childType = null;
        }

        const taxCopy = JSON.parse(JSON.stringify(this.tax));
        taxCopy.stampTaxList.forEach((e: any) => {
            e.type = e.type.id;
            if (e.childType) e.childType = e.childType.id;
        });

        Vue.axios
            .post(
                `stamptax?accountBookId=${this.$store.state.accountBook.id}&period=${this.period}`,
                taxCopy
            )
            .then(() => {
                this.fetchData();
            });
    }
    addRow() {
        if (
            this.newRow.type.id !== null &&
            (this.newRow.taxAmount != "" || this.newRow.approvalBasis != "")
        ) {
            this.stampTaxList.push(this.newRow);
            this.resetNewRow();
            this.tax.stampTaxList = this.stampTaxList;
            this.changeRow();
        } else {
            this.$message.warning("亲，请填写完整数据！");
        }
    }
    remove(index: number) {
        if (this.tax.stampTaxList.length === 1) {
            this.tax.stampTaxList = [];
        } else {
            this.tax.stampTaxList.splice(index, 1);
        }
        this.changeRow();
    }
}
